const ListComponent = ({ title, subTitle, description, list }) => {
  return (
    <div className="text-gray-900">
      {title && (
        <div className="text-xl font-bold text-gray-900 mb-3">{title}</div>
      )}
      {subTitle && (
        <div className="text-lg font-semibold text-gray-900 mb-3">
          {subTitle}
        </div>
      )}
      {description && <p className="text-lg mb-5">{description}</p>}
      <ul className="ml-10 list-disc text-lg">
        {list?.map((para, index) => (
          <li key={index} className="">
            {para?.head && (
              <span className="font-semibold">
                {para?.head}
                {": "}
              </span>
            )}
            {para?.content && <span className="">{para?.content}</span>}
            {typeof para === "string" && <span className="">{para}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ListComponent;
